import { useState } from "react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Reserve } from "@/components/site/Reserve";
import { Specials } from "@/components/site/Specials";
import { SPECIALS } from "@/lib/content";
import { Contact, Footer } from "@/components/site/Contact";
import { scrollToId } from "@/components/site/Reveal";

export default function Home() {
  const [services, setServices] = useState([]);
  const [tab, setTab] = useState("book");
  const [promo, setPromo] = useState(null);

  const applyCode = (code) => {
    const s = SPECIALS.find((x) => x.code === code);
    setPromo({ code, percent: s?.percent ?? 0, label: s?.text ?? "" });
    setTab("book");
    scrollToId("book");
  };

  const pick = (id) => {
    setServices((s) => (s.includes(id) ? s : [...s, id]));
    setTab("book");
    scrollToId("book");
  };

  const goTab = (id) => {
    setTab(id);
  };

  return (
    <main data-testid="home-page">
      <Nav />
      <Hero onTab={goTab} />
      <Marquee />
      <Services onPick={pick} />
      <Process />
      <Specials onUse={applyCode} />
      <Reserve tab={tab} setTab={setTab} services={services} setServices={setServices} promo={promo} setPromo={setPromo} />
      <Contact />
      <Footer />
    </main>
  );
}
